class Footer {
  constructor () {
    this.$footer = $('#genesis-footer-widgets')
    this.$menu = $('.menuMobile')
    
    this.init()
  }
  
  init () {
    //  create html
    this._createHtml()
  }
  
  /**
   * create html
   * @private
   */
  _createHtml () {
    this.$footer.prepend(`<ul class="menuFooter">${this.$menu.html()}</ul>`)
  }
}

export default Footer
